import React from 'react';

import classes from './HeatmapTitleRow.module.scss';
import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import { timeFormat } from '../../../../../shared/constants/apiDateFormat';
import { HEATMAP_HOUR_TIME_SLOTS } from '../ScanningPeakHoursWidget.settings';

const HeatmapTitleRow = () => (
  <>
    <div aria-hidden />
    {HEATMAP_HOUR_TIME_SLOTS.map((time) => (
      <div key={time} className={classes.hourCell}>
        {getFormattedDate(time, 'hha', timeFormat)}
      </div>
    ))}
  </>
);

export { HeatmapTitleRow };
